import EventTimeZoneService from 'src/modules/eventTimeZone/eventTimeZoneService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'EVENTTIMEZONE_VIEW';

const eventTimeZoneViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventTimeZoneViewActions.FIND_STARTED,
      });

      const record = await EventTimeZoneService.find(id);

      dispatch({
        type: eventTimeZoneViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventTimeZoneViewActions.FIND_ERROR,
      });

      getHistory().push('/event-time-zone');
    }
  },
};

export default eventTimeZoneViewActions;
